// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ehFQ","name":"Header_name__1GSUZ","birthday":"Header_birthday__3U4hb","skeleton":"Header_skeleton__3k-Fk"};